import { createFileRoute } from '@tanstack/react-router';
import { OverviewScreen } from '../screens/Overview/OverviewScreen';

export const Route = createFileRoute('/')({
  component: OverviewPage,
});

function OverviewPage() {
  return <OverviewScreen />;
}
